<ng1-profile-welcome [memberType]="memberType"></ng1-profile-welcome>
